module.exports = __webpack_public_path__ + "img/ics_f_arrow-circle-right.9c25a906.svg";